import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getSchemaCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.code'],
);

export const getCompanyName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.company.companyname'],
);

export const getVATNumber = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.company.vatnumber'],
);

export const getSchemaName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.name'],
);

export const getCompany = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.company'],
);

export const getRedemptionThreshold = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.loyaltyschema.redemptionthreshold'],
);

export const getPrintedCards = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.printedcards'],
);

export const getInvoices = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.invoices'],
);

export const getSortCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.schemas.creation_date'],
);

export const getSortSchemaCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.schemas.schema_code'],
);

export const getSortSchemaName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.schemas.schema_name'],
);

export const getUpdateSchemaInfo = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.update-modallabel'],
);

export const getDefaultCountry = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.defaultcountry'],
);

export const getChooseCompany = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.choosecompany'],
);

export const getOrCreate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.orcreate'],
);

export const getSchemaLevel = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.loyaltyschema.tableloyaltyschemalevel'],
);

export const getNexusAccount = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.nexusaccount'],
);

export const getRedemptionType = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.loyaltyschema.loyaltyschemaredemptiontype'],
);

export const getUsePrintedCards = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.useprintedcards'],
);

export const getUseInvoices = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.useinvoices'],
);

export const getTicketsEmailForward = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.ticketsemailforward'],
);

export const getTicketsEmailSenderName = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.ticketsemailsendername'],
);

export const getWelcomeKitsEmailForward = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.welcomekitsemailforward'],
);

export const getWelcomeKitsMinSize = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.welcomekitsminsize'],
);

export const getWelcomeKitsMaxSize = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.welcomekitsmaxsize'],
);

export const getChoosePassword = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.choosepassword'],
);

export const getVerifyPassword = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.verifypassword'],
);

export const getTicketsConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.ticketsconfiguration'],
);

export const getWelcomeKitsConfiguration = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.welcomakitsconfiguration'],
);

export const getPassword = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.schema.password'],
);

export const getNewCompany = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.company.newcompany'],
);

export const getCountry = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.tablecountry.country'],
);

export const getTaxOffice = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.company.taxoffice'],
);

export const getWebSiteURL = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.company.websiteurl'],
);
